import { FunctionComponent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import { fetchGet } from "../../../service/api_client";

import {
  unitMeasureDefaultValue,
  UnitMeasureModel,
} from "../models/item_unit_model";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import EntityHistory, {
  GetMasterLogsByEntityApi,
} from "../../purchase_order/purchase_order_create/components/entity_logs";
import { Clock } from "react-feather";
import "../../../styles/responsive_shrink.css";

interface ItemUnitViewScreenProps {
  data?: UnitMeasureModel;
  onClose?: (id: UnitMeasureModel) => void;
}

const ItemUnitViewScreen: FunctionComponent<ItemUnitViewScreenProps> = (
  props
) => {
  const { id } = useParams<{ id: string }>();

  const [loading, setLoading] = useState(false);
  const [showHistory, setShowHistory] = useState(false);

  const { showToast } = useToast();
  const [data, setData] = useState<UnitMeasureModel>({
    ...(props.data || unitMeasureDefaultValue),
  });
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/units`;

  useEffect(() => {
    if (id) getData(id);
  }, [id]);

  const getData = async (id: string) => {
    setLoading(true);
    const res = await fetchGet(url + "/" + id);
    if (res.success) {
      setData(res.data);
    } else showToast({ type: ToastType.error, text: res.error });
    setLoading(false);
  };

  return (
    <div className="mobile-shrink">
      <div className="p-3 md:p-10 flex flex-col gap-5">
        <div className="flex items-center justify-end">
          {data?.id && (
            <button
              id="history_btn"
              onClick={() => setShowHistory(true)}
              className="flex items-center gap-1 text-sm hover:text-gray-600  text-myPrimaryColor"
              title="View History"
            >
              <Clock size={32} />
            </button>
          )}
        </div>
        <div className="flex flex-col items-start text-sm w-full">
          <label className="font-semibold w-full" htmlFor="symbol">
            Symbol
          </label>
          <input
            placeholder="Enter name"
            className="p-1 rounded  focus:outline-none w-full border bg-gray-100 cursor-not-allowed"
            id="symbol"
            name="symbol"
            value={data.symbol || ""}
            disabled
            type="text"
          ></input>
        </div>
        <div className="flex flex-col items-start text-sm w-full">
          <label className="font-semibold w-full" htmlFor="name">
            Formal name
          </label>
          <input
            placeholder="Enter name"
            className="p-1 rounded  focus:outline-none w-full border bg-gray-100 cursor-not-allowed"
            id="name"
            name="name"
            value={data.formal_name || ""}
            disabled
            type="text"
          ></input>
        </div>

        <div className="flex flex-col items-start text-sm w-full">
          <label className="font-semibold w-full" htmlFor="unit">
            Unique Quantity Code
          </label>
          <input
            className="p-1 rounded  focus:outline-none w-full border bg-gray-100 cursor-not-allowed"
            id="unit"
            value={data.uqc || ""}
            disabled
            type="text"
          />
        </div>
      </div>
      {loading && <LoadingWidget />}
      {showHistory && data?.id && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={showHistory}
          onClose={() => setShowHistory(false)}
          title="Item Unit History"
        >
          <EntityHistory
            fetchLogs={({ page, count }) =>
              GetMasterLogsByEntityApi({
                entityType: "item unit",
                entityId: data.id,
                page,
                count,
              })
            }
          />
        </DrawerModal>
      )}
    </div>
  );
};

export default ItemUnitViewScreen;
